import { ENewbuildingPromoFeaturesActionType } from './types';
import { IFeaturesMap } from '../../types/map';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setNewbuildingPromoFeatures = actionGenerator<
  ENewbuildingPromoFeaturesActionType.SetNewbuildingPromoFeatures,
  IFeaturesMap
>(ENewbuildingPromoFeaturesActionType.SetNewbuildingPromoFeatures);
